import React from 'react';

import { SvgLineWrapper, SvgLine } from './RoLine.styles';

const Line = props => {
  const { handle, pixelCoord, pickerBoardPosition } = props.bounding;

  const pickerBoard = {
    x: pickerBoardPosition && window.innerWidth * (pickerBoardPosition / 100),
    y: 30
  };
  return (
    <SvgLineWrapper>
      {pixelCoord && (
        <SvgLine>
          <line
            stroke="#7e57c2"
            strokeDasharray="8, 7"
            strokeWidth="1"
            x1={pixelCoord[0]}
            y1={pixelCoord[1] - 10}
            x2={handle.left + handle.width / 2}
            y2={handle.top - 11}
          />
          {!!pickerBoardPosition && (
            <line
              stroke="#7e57c2"
              strokeDasharray="8, 7"
              strokeWidth="1"
              x1={pixelCoord[0]}
              y1={pixelCoord[1] - 10}
              x2={pickerBoard.x}
              y2={pickerBoard.y + 2}
            />
          )}
          {!!pickerBoardPosition && (
            <circle cx={pickerBoard.x} cy={pickerBoard.y} r="1" stroke="#7e57c2" strokeWidth="4" fill="none" />
          )}
          <circle
            id={'currentPoint'}
            cx={pixelCoord[0]}
            cy={pixelCoord[1] - 10}
            r="1"
            stroke="#7e57c2"
            strokeWidth="15"
            fill="none"
          />
          <circle
            cx={handle.left + handle.width / 2}
            cy={handle.top - 10}
            r="1"
            stroke="#fff"
            strokeWidth="4"
            fill="none"
          />
        </SvgLine>
      )}
    </SvgLineWrapper>
  );
};

export default Line;
